export function normalizeAssetMimeType(
  fileName: string,
  declaredMimeType: string,
): string {
  const lowerName = fileName.toLowerCase();
  if (lowerName.endsWith(".glb")) return "model/gltf-binary";
  if (lowerName.endsWith(".gltf")) return "model/gltf+json";
  return declaredMimeType;
}
